import * as React from "react";
import { TextField, Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Dropdown from "components/Dropdown/Dropdown";
import { getAllObjectTypes } from "actions/AuditAndRevisions/AuditAndRevisionsActions";
import GenericSpinner from "components/GenericSpinner/GenericSpinner";
import { useNavigate, useLocation } from "react-router-dom";
import { serializeQueryParamsIntoStr } from "../../commonFunctions";

interface IAuditSearchProps {
  setIsAttendee: any,
}

const AuditSearch: React.FunctionComponent<IAuditSearchProps> = (props) => {

  const [pageLoaded, setPageLoaded] = React.useState(false);

  React.useEffect(() => {
    if(!pageLoaded) {
      setPageLoaded(true);
      props.setIsAttendee(false);
    }
  })

  const [searchFieldValues, setSearchFieldValues] = React.useState({
    startDate: "",
    endDate: "",
    auditSearchObjectType: "",
  });

  const onChange = (e: any) => {
    const { name, value } = e.target;
    setSearchFieldValues({ ...searchFieldValues, [name]: value });
    props.setIsAttendee(value === "Attendee");
  };

  const [
    objectTypesRequestPending,
    setObjectTypesRequestPending,
  ] = React.useState(true);

  const navigate = useNavigate();

  const [objectTypes, setObjectTypes] = React.useState([""]);

  React.useEffect(() => {
    setObjectTypesRequestPending(true);
    getAllObjectTypes()
      .then((response) => {
        setObjectTypes(objectTypes.concat(response.data));
        setObjectTypesRequestPending(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onFormSubmit = (e: any) => {
    e.preventDefault();

    const params = serializeQueryParamsIntoStr(searchFieldValues);

    navigate({
      pathname: "/audit-and-revisions/search-results",
      search: params,
    });
  };

  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <h2>Audit and History Revisions Search</h2>
      </Grid>
      <form onSubmit={onFormSubmit} method={"post"} className="w-100">
        <Grid
          container
          size={{ xs: 12 }}
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              fullWidth
              id={"audit-search-start-date"}
              label="Start Date"
              name="startDate"
              onChange={onChange}
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              variant="outlined"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              fullWidth
              id={"audit-search-end-date"}
              label="End Date"
              onChange={onChange}
              name="endDate"
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              variant="outlined"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            {objectTypesRequestPending ? (
              <GenericSpinner includeOverlay={false} padding={0} />
            ) : (
              <Dropdown
                id={"audit-search-objectType-dropdown"}
                name={"auditSearchObjectType"}
                onChange={onChange}
                label={"Object Type"}
                selectedPropsValue={
                  searchFieldValues.auditSearchObjectType
                }
                values={objectTypes.map((objectType: any, index: number) => {
                  return (
                    <option key={index} value={objectType}>
                      {objectType}
                    </option>
                  );
                })}
              />
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 3 }} className="pt-3">
            <Button
              className="btn"
              type="submit"
              fullWidth
              size="large"
              variant="contained"
              color="primary"
            >
              Search Audit Records
            </Button>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default AuditSearch;
